export enum LoaiDoiTuong {
    NONE = "0",
    CPXD = "1",
   
}